module.exports = __webpack_public_path__ + "static/media/views-on-cybersecurity-cover-en.49682a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/views-on-cybersecurity-cover-en.png
// module id = 559
// module chunks = 0